import { Component, EventEmitter, Input, OnInit, Output, SimpleChange} from '@angular/core';
import { throwError } from 'rxjs';
import { take } from 'rxjs/operators';
import { httpConnect } from 'src/app/services/httpConnect.service';
import { MatDialog } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'cat-select',
  templateUrl: './cat-select.component.html',
  styleUrls: ['./cat-select.component.scss']
})
export class CatSelect implements OnInit {
  private connectSvc;
  private opt : {};

  @Input() type: any = {};
  @Input()  placeholder :string = "";
  @Input() acValue : any;  
  @Output() acValueChange = new EventEmitter<any>();
  @Input() data : any[];
  @Input() labelAppearance: string;
  @Input() isSubmitted:boolean = false;
  @Input() isRequired:boolean = false;
  @Input() textError:string;
  defaultSelected;
  public selectFormControl:FormControl;
  public lblrequired:string = "";
  

  dataSource: any = [];
  constructor(public dialog: MatDialog, httpConn: httpConnect) {
    this.connectSvc = httpConn;
    this.labelAppearance = this.labelAppearance || 'mat-form-field-no-label';    
   }
 ngOnInit() {
      this.placeholder = this.type.label;
      if(this.isRequired){
        this.selectFormControl = new FormControl([],Validators.required);
        this.lblrequired = "labelRequerido"
      }else{
        this.selectFormControl = new FormControl();
      }
      this.GetDatCombo();
  }
  ngOnChanges(changes: { [propName: string]: SimpleChange }){   
     if(changes.acValue && this.acValue != {}){
       if (this.data) {         
        this.defaultSelected = this.data[0];
       }  
     }

  }

  public OnBlur(){
    setTimeout(() => {
      // this.acValueChange.emit(this.acValue);  
      // this.acValueChange.emit(this.opt);
      if(this.opt !== undefined)
        this.labelAppearance = '';
    }, 300);  
  }


  GetDatCombo(){  
    let params = {
      catalogo: this.type.tblName,
    }
    this.connectSvc.postAPI("General", "GetComboData",params)
    .pipe(
           take(1)
    )
    .subscribe(result => {
      this.dataSource = result.response;
      // this.acValueChange.emit(result.response);

    },err => {
      return throwError(err.error);
    });
}

public ActualizaOptionSelected(ev:any){
  this.opt = ev.value;
  this.acValueChange.emit(this.opt);
}



}
